import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ClearBtn, SearchBtn } from "../../Buttons/Buttons";
import { useDispatch } from "react-redux";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { postAddUsersData } from "../../redux/action";

const AddUserModal = ({ show, handleClose, sbnID, signinID, fetchUsersData, username, email, phone, setUsername, setEmail, setPhone }) => {

    const dispatch = useDispatch();

    const [errors, setErrors] = useState({});

    const validateFields = () => {
        const newErrors = {};

        if (!username.trim()) {
            newErrors.username = "Username is required";
        }

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = "Email is invalid";
        }

        if (!phone.trim()) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\d{10}$/.test(phone)) {
            newErrors.phone = "Phone must be 10 digits";
        }

        return newErrors;
    };

    const handleAddUsers = (e) => {
        e.preventDefault();

        const validationErrors = validateFields();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            const requestPayload = {
                user_id: parseInt(signinID),
                sbn_id: sbnID,
                name: username,
                email: email,
                phone: phone,
                role: 'user'
            };

            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.updateAuthOfLeadMerge,
                body: JSON.stringify(requestPayload),
            };

            dispatch(postAddUsersData(requestOption, fetchUsersData, handleClose));
        }
    };

    return (
        <Modal show={show} onHide={handleClose} className='saved-search-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Create User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formUsername">
                        <Form.Label className="fw-semibold">Username</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setErrors((prev) => ({ ...prev, username: "" }));
                            }}
                        />
                        {errors.username && <div className="text-danger">{errors.username}</div>}
                    </Form.Group>

                    <Form.Group controlId="formEmail">
                        <Form.Label className="mt-2 fw-semibold">Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setErrors((prev) => ({ ...prev, email: "" }));
                            }}
                        />
                        {errors.email && <div className="text-danger">{errors.email}</div>}
                    </Form.Group>

                    <Form.Group controlId="formPhone">
                        <Form.Label className="mt-2 fw-semibold">Phone</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter phone number"
                            value={phone}
                            onChange={(e) => {
                                setPhone(e.target.value);
                                setErrors((prev) => ({ ...prev, phone: "" }));
                            }}
                        />
                        {errors.phone && <div className="text-danger">{errors.phone}</div>}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <ClearBtn btnName='Cancel' onClickEffect={handleClose} />
                <SearchBtn btnName='Submit' onClickEffect={handleAddUsers} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddUserModal;
